import { useTranslations } from '@vocab/react';
import { Alert, Stack, Text } from 'braid-design-system';
import React, { type FunctionComponent } from 'react';

import translations from './.vocab';

export const CheckoutPageError: FunctionComponent = () => {
  const { t } = useTranslations(translations);

  return (
    <Alert tone="critical">
      <Stack space="medium">
        <Text weight="strong">{t('checkout-page-error-title')}</Text>
        <Text>{t('checkout-page-error-text-content')}</Text>
      </Stack>
    </Alert>
  );
};
